import React, { FC } from 'react';

import { LucidTheme } from '@lucid/theme';

import Box from '../../../components/box/box';
import Heading from '../../../components/heading/heading';
import ImageWithPlaceholder from '../../../components/image/image-with-placeholder';
import Text from '../../../components/text/text';
import { ComponentImage } from '../../../types/generics';

export interface HorizontalCardProps extends ComponentImage {
  footer: string;
  title: string;
  className?: string;
  size?: 'large' | 'medium';
  tag?: string;
}

const HorizontalCard: FC<HorizontalCardProps> = ({ className, imageAlt, imageSrc, footer, title, size = 'medium', tag }) => {
  return (
    <Box className={className} css={{ alignItems: 'center', display: 'grid' }}>
      <ImageWithPlaceholder alt={imageAlt || ''} aspectRatio="1:1" src={imageSrc} />
      <Box
        css={(theme: LucidTheme) => ({
          padding: theme.space.s16,
        })}
      >
        {tag && <Text mb={2} variant="labelXS400">{tag}</Text>}
        <Heading as="h6" mb={3} variant={size === 'medium' ? 'headlineM' : 'headlineL'}>{title}</Heading>
        <Text variant="paragraphS400">{footer}</Text>
      </Box>
    </Box>
  );
};

export default HorizontalCard;
export { HorizontalCard };
